import { Component, input, output } from '@angular/core';
import { Property } from 'app/types';

@Component({
  selector: 'app-suggested-property',
  templateUrl: './suggested-property.component.html',
  styleUrl: './suggested-property.component.scss',
})
export class SuggestedPropertyComponent {
  $property = input<Property | undefined>(undefined, { alias: 'property' });
  ignoreSuggestedProperty = output<Property | undefined>();
}
